// src/features/integration/integrationSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
    getIntegrations,
    deleteIntegration,
    getIntegrationById,
    getRunHistory,
    upsertIntegration,
    getRunLogData
} from '@Common/services/httpservice';

// Define the initial state
const initialState = {
    integrations: [],
    integrationsCount: 0,
    selectedIntegration: null,
    runHistory: [],
    logData: [],
    logdataLoadingStatus: 'idle',
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
    currentWorkflow: {
        workflowName: "New Workflow",
        workflowDescription: "Workflow Description",
        actionsNew: [{"id":"triggerRequestAction","type":"triggerRequest","data":{"label":"Set Trigger"},"position":{"x":250,"y":60},"draggable":true,"invokeAfter":[],"width":140},{"id":"parent-1","type":"foreach","data":{"label":"Parent Node"},"position":{"x":250,"y":190},"draggable":true,"invokeAfter":[{"id":"triggerRequestAction","status":"success"}]},{"id":"getDataSourceAction","type":"restApi","data":{"label":"Get Data"},"position":{"x":30,"y":20},"draggable":true,"parentId":"parent-1","extent":"parent","width":140,"height":60},{"id":"getDataSourceAction2","type":"restApi","data":{"label":"Get Data"},"position":{"x":191.5,"y":153},"draggable":true,"invokeAfter":[{"id":"getDataSourceAction","status":"success"}],"parentId":"parent-1","extent":"parent","width":140,"height":60}],
        actions: [
            {
                "id": "triggerRequestAction",
                "type": "triggerRequest",
                "data": { "label": "Set Trigger" },
                "position": { "x": 250, "y": 60 },
                "draggable": true,
                "invokeAfter": [],
                "width": 140, // Optional: Set a width for the trigger node
            },
            {
                "id": "parent-1",
                "type": "foreach",
                "data": { "label": "Parent Node" },
                "position": { "x": 250, "y": 190 },
                // "style": {
                //     border: '2px solid #0000FF',
                //     backgroundColor: '#f0f8ff',
                //     padding: 10,
                //     borderRadius: 10,
                // },
                "draggable": true,
                "invokeAfter": [{ "id": "triggerRequestAction", "status": "success" }],
                // "width": 210, 
                // "height": 180,
            },
            // {
            //     "id": "getDataSourceAction",
            //     "type": "restApi",
            //     "data": { "label": "Get Data" },
            //     "position": { "x": 250, "y": 150 },
            //     "draggable": true,
            //     "invokeAfter": [{ "id": "triggerRequestAction", "status": "success" }],
            //     // "parentId": 'parent-1', // Set the parent node ID
            //     // "extent": 'parent',
            //     "width": 140, // Optional: Set a width for the action node
            // },
            {
                "id": "getDataSourceAction",
                "type": "restApi",
                "data": { "label": "Get Data" },
                "position": { "x": 30, "y": 20 },
                "draggable": true,
                // "invokeAfter": [{ "id": "triggerRequestAction", "status": "success" }],
                "parentId": 'parent-1', // Set the parent node ID
                "extent": 'parent',
                "width": 140,
                "height": 60, // Optional: Set a height for the action node
            },
            {
                "id": "getDataSourceAction2",
                "type": "restApi",
                "data": { "label": "Get Data" },
                "position": { "x": 40, "y": 80 },
                "draggable": true,
                "invokeAfter": [{ "id": "getDataSourceAction", "status": "success" }],
                "parentId": 'parent-1', // Set the parent node ID
                "extent": 'parent',
                "width": 140,
                "height": 60,
            },
            // {
            //     "id": "triggerResponseAction",
            //     "type": "triggerResponse",
            //     "data": { "label": "Response" },
            //     "position": { "x": 112.45399239543724, "y": 445.7003802281369 },
            //     "draggable": true, "invokeAfter": [
            //         {
            //             "id": "getDataSourceAction",
            //             "status": "success"
            //         },
            //         {
            //             "id": "getDataSourceAction2",
            //             "status": "success"
            //         }
            //     ]
            // },
            // {
            //     "id": "triggerErrorResponseAction",
            //     "type": "triggerResponse",
            //     "data": { "label": "Error Response" },
            //     "position": { "x": 377.50038022813686, "y": 435.9581749049429 },
            //     "draggable": true,
            //     "invokeAfter": [
            //         {
            //             "id": "getDataSourceAction",
            //             "status": "failed"
            //         },
            //         {
            //             "id": "getDataSourceAction2",
            //             "status": "failed"
            //         }
            //     ]
            // }
        ],
        edges: [
            // {
            //     id: `e1-2`,
            //     source: "1",
            //     target: "2",
            //     type: "simplebezier",
            //     style: { strokeWidth: 1, stroke: "#000" },
            // }
        ]
    }
};

// Create an async thunk for saving an integration
export const saveIntegrationAsync = createAsyncThunk(
    'integrations/saveIntegration',
    async ({ id, integrationDetails, status }, { getState, rejectWithValue }) => {
        try {

            const state = getState();
            const selectedIntegration = state.integration.selectedIntegration;

            if (!selectedIntegration || !selectedIntegration.name || !selectedIntegration.description) {
                //   toast.error("Please fill in both the Name and Description fields.");
                return rejectWithValue("Please fill in both the Name and Description fields in Overview tab.");
            }

            // Create a copy of integrationDetails to avoid modifying the original object
            const integrationDetailsToSave = { ...selectedIntegration };

            integrationDetailsToSave.listener_type = integrationDetailsToSave.triggerDetails.triggerType;
            if(integrationDetailsToSave.listener_type === "SNS"){
                const snsConfig = {
                    topic_arn: integrationDetailsToSave.triggerDetails.triggerAwsSNSTopicArn,
                    region_name: integrationDetailsToSave.triggerDetails.triggerAwsRegion,
                    aws_access_key_id: integrationDetailsToSave.triggerDetails.triggerAwsAccessKeyId,
                    aws_secret_access_key: integrationDetailsToSave.triggerDetails.triggerAwsSecretAccessKey
                }
                integrationDetailsToSave.config = snsConfig;
                integrationDetailsToSave.is_active = true;
            }

            if(integrationDetailsToSave.listener_type === "SQS"){
                const sqsConfig = {
                    queue_url: integrationDetailsToSave.triggerDetails.triggerAwsSQSQueueURL,
                    region_name: integrationDetailsToSave.triggerDetails.triggerAwsRegion,
                    aws_access_key_id: integrationDetailsToSave.triggerDetails.triggerAwsAccessKeyId,
                    aws_secret_access_key: integrationDetailsToSave.triggerDetails.triggerAwsSecretAccessKey
                }
                integrationDetailsToSave.config = sqsConfig;
                integrationDetailsToSave.is_active = true;
            }

            if(integrationDetailsToSave.listener_type === "SALESFORCE"){  
                const sfConfig = {
                    instance_url: integrationDetailsToSave.triggerDetails.triggerSfInstanceUrl,
                    topic_name: integrationDetailsToSave.triggerDetails.triggerSfTopicName,
                    username: integrationDetailsToSave.triggerDetails.triggerSfUserName,
                    password: integrationDetailsToSave.triggerDetails.triggerSfPassword,
                    security_token: integrationDetailsToSave.triggerDetails.triggerSfSecurityToken,
                    client_id: integrationDetailsToSave.triggerDetails.triggerSfClientId,
                    client_secret: integrationDetailsToSave.triggerDetails.triggerSfClientSecret
                }
                integrationDetailsToSave.config = sfConfig;
                integrationDetailsToSave.is_active = true;
            }

            // Convert nested details to JSON strings
            const nestedDetails = ['triggerDetails', 'sourceDetails', 'destinationDetails', 'mappingDetails', 'metadata', 'config'];
            nestedDetails.forEach(detail => {
                if (integrationDetailsToSave[detail]) {
                    integrationDetailsToSave[detail] = JSON.stringify(integrationDetailsToSave[detail]);
                }
            });

            // console.log(integrationDetailsToSave.mappingDetails);

            return await upsertIntegration(id, integrationDetailsToSave, status);
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Create an async thunk for fetching a single integration by ID
export const fetchIntegrationById = createAsyncThunk(
    'integrations/fetchIntegrationById',
    async (integrationId, { getState, rejectWithValue }) => {
        const state = getState();
        // Check if the selectedIntegration already has the same ID
        if (state.integration.selectedIntegration && state.integration.selectedIntegration.integration_id === integrationId) {
            // Return the existing selectedIntegration to avoid refetching
            return state.integration.selectedIntegration;
        }
        try {
            const response = await getIntegrationById(integrationId);
            if (response && response.message && response.message === 'Integration not found') {
                return {
                    integration_id: integrationId,
                    triggerDetails: {
                        triggerType: "None",
                        triggerHttpMethod: "POST",
                        triggerRequestSchema: "",
                        triggerResponseSchema: "",
                        triggerCronExpression: ""
                    },
                    sourceDetails: {
                        sourceType: "REST API",
                        restAPIHttpMethod: "GET",
                        restAPIUrl: "",
                        restAPISourceRequestSchema: "",
                        restAPISourceResponseSchema: "",
                        restAPIAuthType: "No Auth",
                        sourceDBType: "SQL Server"
                    },
                    destinationDetails: {
                        destinationType: "REST API",
                        restAPIHttpMethod: "POST",
                        restAPIUrl: "",
                        restAPIDestinationRequestSchema: "",
                        restAPIDestinationResponseSchema: "",
                        restAPIAuthType: "No Auth",
                        destinationDBType: "SQL Server"
                    },
                    mappingDetails: {},
                    metadata: {},
                    isNew: true,
                };
            }
            return {...response, isNew: false};
        } catch (error) {
            return rejectWithValue(error.message);
        }
    },
    {
        condition: (integrationId, { getState }) => {
            const state = getState();
            // Check if the selectedIntegration already has the same ID
            if (state.integration.selectedIntegration && state.integration.selectedIntegration.integration_id === integrationId) {
                // Skip the thunk if the condition is met
                return false;
            }
            return true;
        },
    }
);

// Create an async thunk for fetching integrations
export const fetchIntegrations = createAsyncThunk(
    'integrations/',
    async ({ page, page_size, status }) => {        
        return await getIntegrations(page, page_size, status);
    }
);

// Create an async thunk for deleting an integration
export const deleteIntegrationAsync = createAsyncThunk(
    'integrations/deleteIntegration',
    async (integrationId) => {
        const response = await deleteIntegration(integrationId);
        return { integrationId, response }; // Return both ID and response
    }
);

export const getInvocations = createAsyncThunk(
    'integrations/getInvocations',
    async (integrationId) => {
        const response = await getRunHistory(integrationId, 1, 50);
        return response;
    }
);

export const getLogData = createAsyncThunk(
    'integrations/getLogData',
    async (run_id) => {
        const response = await getRunLogData(run_id);
        return response;
    }
);

// Create the slice
const integrationSlice = createSlice({
    name: 'integrations',
    initialState,
    reducers: {
        deleteWorkflowNode: (state, action) => {
            const { nodeId } = action.payload;
            const nodeToDelete = state.currentWorkflow.actions.find(actionNode => actionNode.id === nodeId);
            if (nodeToDelete) {
                const invokeAfterIds = nodeToDelete.invokeAfter;
                const descedentNodes = state.currentWorkflow.actions.filter(actionNode => {
                    return actionNode.invokeAfter.some(invokeAfter => invokeAfter.id === nodeId);
                });
                if (descedentNodes.length > 0) {
                    descedentNodes.forEach(actionNode => {
                        if(actionNode.invokeAfter.length == 1){
                            actionNode.invokeAfter = invokeAfterIds
                        } else {
                            actionNode.invokeAfter.forEach(invokeAfter => {
                                if (invokeAfter.id === nodeId) {
                                    invokeAfter.id = invokeAfterIds[0].id;
                                }
                            });
                        }
                    });
                }

                state.currentWorkflow.actions = state.currentWorkflow.actions.filter(actionNode => actionNode.id !== nodeId);
                state.currentWorkflow.actions.forEach(actionNode => {

                    if (actionNode.position.y > nodeToDelete.position.y) {
                        actionNode.position.y -= 140;
                    }
                });
            }
        },
        addActionToWorkflow: (state, action) => {
            const { newAction, oldConnectedNodes, nextNodePositionY } = action.payload;

            // get the node under which we are adding the new node and get position x
            const parentNode = state.currentWorkflow.actions.find(action => action.id === newAction.invokeAfter[0].id);
            
            // console.log(JSON.parse(JSON.stringify(parentNode)));
            //console.log(nextNodePositionY);

            // let skipPushingY = false;
            
            if (parentNode) {
                newAction.position.x = parentNode.position.x;
                newAction.position.y = parentNode.position.y + nextNodePositionY + 10;
                // skipPushingY = true;

            }

            
            oldConnectedNodes.forEach(nodeId => {
                const preConnectedNode = state.currentWorkflow.actions.find(actionNode => actionNode.id === nodeId);
                if (preConnectedNode) {
                    // console.log(JSON.parse(JSON.stringify(preConnectedNode)));
                    const existingInvokeAfter = preConnectedNode.invokeAfter.find(invokeAfter => invokeAfter.id === newAction.invokeAfter[0].id);

                    if (existingInvokeAfter) {
                        existingInvokeAfter.id = newAction.id;
                        //preConnectedNode.position.y = newAction.position.y + 30;
                        // console.log("skipPushingY = true");
                        // skipPushingY = true;
                    }
                }
            });

            let invokeAfterId = newAction.id;
            while (state.currentWorkflow.actions.some(actionNode => actionNode.invokeAfter.some(invokeAfter => invokeAfter.id === invokeAfterId))) {
                // If there's a circular reference or an infinite loop, break the loop
                console.log()
            }
            

            // update position.y of all the nodes whose y is equal to or greater than new action y

            // state.currentWorkflow.actions.forEach(actionNode => {
            //     if (actionNode.position.y >= newAction.position.y) {
            //         actionNode.position.y += 60;
            //         // console.log(JSON.parse(JSON.stringify(actionNode)));
            //     } else if(actionNode.parentId === newAction.parentId && actionNode.position.y >= newAction.position.y ) {

            //         // actionNode.position.y += 60;

            //         // TODO set the postion.y of the old nodes after the new action
            //         // console.log("TODO????")
            //         // console.log(JSON.parse(JSON.stringify(actionNode)));
            //         // console.log(JSON.parse(JSON.stringify(newAction)));

            //     }
            // });

            state.currentWorkflow.actions.push(newAction); // Add the new action
        },
        updateWorkflowNodePosition: (state, action) => {
            const { id, position } = action.payload;
            const actionIndex = state.currentWorkflow.actions.findIndex((a) => a.id === id);

            if (actionIndex !== -1) {
                state.currentWorkflow.actions[actionIndex].position = position;
            }

            // console.log(state.currentWorkflow.actions);
            // console.log(JSON.stringify(state.currentWorkflow.actions));
            
        },
        updateWorkflowNode: (state, action) => {
            const { id, label } = action.payload;
            console.log(id, label);
            const selectedNode = state.currentWorkflow.actions.find(action => action.id === id);
            if (selectedNode) {
               selectedNode.data.label = label;
            }
        },
        updateWorkflow: (state, action) => {

            console.log(action.payload);

            state.currentWorkflow = {
                ...state.currentWorkflow,
                ...action.payload,
            };
        },
        updateIntegration: (state, action) => {
            state.selectedIntegration = {
                ...state.selectedIntegration,
                ...action.payload,
            };
        },
        updateIntegrationTriggerDetails: (state, action) => {
            if (!state.selectedIntegration.triggerDetails) {
                state.selectedIntegration.triggerDetails = {};
            }
            state.selectedIntegration.triggerDetails[action.payload.key] = action.payload.value;
            
            // If this is an AWS credential field, also update the config
            if (action.payload.key === 'triggerAwsRegion') {
                if (!state.selectedIntegration.config) {
                    state.selectedIntegration.config = {};
                }
                state.selectedIntegration.config.region_name = action.payload.value;
            } else if (action.payload.key === 'triggerAwsAccessKeyId') {
                if (!state.selectedIntegration.config) {
                    state.selectedIntegration.config = {};
                }
                state.selectedIntegration.config.aws_access_key_id = action.payload.value;
            } else if (action.payload.key === 'triggerAwsSecretAccessKey') {
                if (!state.selectedIntegration.config) {
                    state.selectedIntegration.config = {};
                }
                state.selectedIntegration.config.aws_secret_access_key = action.payload.value;
            } else if (action.payload.key === 'triggerAwsSNSTopicArn') {
                if (!state.selectedIntegration.config) {
                    state.selectedIntegration.config = {};
                }
                state.selectedIntegration.config.topic_arn = action.payload.value;
            } else if (action.payload.key === 'triggerAwsSQSQueueURL') {
                if (!state.selectedIntegration.config) {
                    state.selectedIntegration.config = {};
                }
                state.selectedIntegration.config.queue_url = action.payload.value;
            }  else if (action.payload.key === 'triggerAzSbQueueName') {
                if (!state.selectedIntegration.config) {
                    state.selectedIntegration.config = {};
                }
                state.selectedIntegration.config.queue_name = action.payload.value;
            } else if (action.payload.key === 'triggerAzSbConnectionString') {
                if (!state.selectedIntegration.config) {
                    state.selectedIntegration.config = {};
                }
                state.selectedIntegration.config.connection_string = action.payload.value;
            } else if (action.payload.key === 'triggerSfInstanceUrl') {
                if (!state.selectedIntegration.config) {
                    state.selectedIntegration.config = {};
                }
                state.selectedIntegration.config.instance_url = action.payload.value;
            } else if (action.payload.key === 'triggerSfTopicName') {
                if (!state.selectedIntegration.config) {
                    state.selectedIntegration.config = {};
                }
                state.selectedIntegration.config.topic_name = action.payload.value;
            } else if (action.payload.key === 'triggerSfUserName') {
                if (!state.selectedIntegration.config) {
                    state.selectedIntegration.config = {};
                }
                state.selectedIntegration.config.username = action.payload.value;
            } else if (action.payload.key === 'triggerSfPassword') {
                if (!state.selectedIntegration.config) {
                    state.selectedIntegration.config = {};
                }
                state.selectedIntegration.config.password = action.payload.value;
            }  else if (action.payload.key === 'triggerSfSecurityToken') {
                if (!state.selectedIntegration.config) {
                    state.selectedIntegration.config = {};
                }
                state.selectedIntegration.config.security_token = action.payload.value;
            }  else if (action.payload.key === 'triggerSfClientId') {
                if (!state.selectedIntegration.config) {
                    state.selectedIntegration.config = {};
                }
                state.selectedIntegration.config.client_id = action.payload.value;
            }  else if (action.payload.key === 'triggerSfClientSecret') {
                if (!state.selectedIntegration.config) {
                    state.selectedIntegration.config = {};
                }
                state.selectedIntegration.config.client_secret = action.payload.value;
            }
        },
        updateIntegrationSourceDetails: (state, action) => {
            state.selectedIntegration.sourceDetails[action.payload.key] = action.payload.value;
        },
        updateIntegrationDestinationDetails: (state, action) => {
            state.selectedIntegration.destinationDetails[action.payload.key] = action.payload.value;
        },
        updateIntegrationMappingDetails: (state, action) => {


            state.selectedIntegration[action.payload.key] = action.payload.value;

            // console.log(state.selectedIntegration.mappingDetails);
        },
        updateIntegrationTriggerDetailsRequestSchema: (state, action) => {
            if (state.selectedIntegration && state.selectedIntegration.triggerDetails) {
                state.selectedIntegration.triggerDetails.triggerRequestSchema = action.payload;
            }
        },
        updateIntegrationTriggerDetailsResponseSchema: (state, action) => {
            if (state.selectedIntegration && state.selectedIntegration.triggerDetails) {
                state.selectedIntegration.triggerDetails.triggerResponseSchema = action.payload;
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchIntegrations.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchIntegrations.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.integrations = action.payload.results;
                state.integrationsCount = action.payload.count;
            })
            .addCase(fetchIntegrations.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            // Handle fetchIntegrationById
            .addCase(fetchIntegrationById.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchIntegrationById.fulfilled, (state, action) => {
                state.status = 'succeeded';
                // console.log('Fetched integration:', action.payload);
                const { triggerDetails, sourceDetails, destinationDetails, mappingDetails, metadata, config, ...rest } = action.payload;
                state.selectedIntegration = {
                    ...rest,
                    triggerDetails: triggerDetails ? (typeof triggerDetails === 'string' ? JSON.parse(triggerDetails) : triggerDetails) : {},
                    sourceDetails: sourceDetails ? (typeof sourceDetails === 'string' ? JSON.parse(sourceDetails) : sourceDetails) : {},
                    destinationDetails: destinationDetails ? (typeof destinationDetails === 'string' ? JSON.parse(destinationDetails) : destinationDetails) : {},
                    mappingDetails: mappingDetails ? (typeof mappingDetails === 'string' ? JSON.parse(mappingDetails) : mappingDetails) : {},
                    metadata: metadata ? (typeof metadata === 'string' ? JSON.parse(metadata) : metadata) : {},
                    config: config ? (typeof config === 'string' ? JSON.parse(config) : metadata) : {},
                };

            })
            .addCase(fetchIntegrationById.rejected, (state, action) => {
                // console.log('Error fetching integration:', action.error);
                state.status = 'failed';
                state.error = action.error.message;
            })

            // Handle deleteIntegrationAsync
            .addCase(deleteIntegrationAsync.pending, (state) => {
                //state.status = 'loading'; // You can set a specific status for delete if needed
            })
            .addCase(deleteIntegrationAsync.fulfilled, (state, action) => {
                //state.status = 'succeeded';
                // Remove the deleted integration from the state
                // state.integrations = state.integrations.filter(
                //   (integration) => integration.integration_id !== action.payload.integrationId
                // );
                // You might also want to update integrationsCount here if you're tracking it
                // state.integrationsCount = state.integrationsCount - 1;
            })
            .addCase(deleteIntegrationAsync.rejected, (state, action) => {
                //state.status = 'failed';
                //state.error = action.error.message;
            })

            // Handle saveIntegrationAsync
            .addCase(saveIntegrationAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(saveIntegrationAsync.fulfilled, (state, action) => {
                state.status = 'succeeded';
                // const { triggerDetails, sourceDetails, destinationDetails, mappingDetails, metadata, ...rest } = action.payload.data;
                // state.selectedIntegration = {
                //     ...rest,
                //     triggerDetails: triggerDetails ? (typeof triggerDetails === 'string' ? JSON.parse(triggerDetails) : triggerDetails) : {},
                //     sourceDetails: sourceDetails ? (typeof sourceDetails === 'string' ? JSON.parse(sourceDetails) : sourceDetails) : {},
                //     destinationDetails: destinationDetails ? (typeof destinationDetails === 'string' ? JSON.parse(destinationDetails) : destinationDetails) : {},
                //     mappingDetails: mappingDetails ? (typeof mappingDetails === 'string' ? JSON.parse(mappingDetails) : mappingDetails) : {},
                //     metadata: metadata ? (typeof metadata === 'string' ? JSON.parse(metadata) : metadata) : {},
                // };
            })
            .addCase(saveIntegrationAsync.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload; // Set the error message
            })
            .addCase(getInvocations.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getInvocations.fulfilled, (state, action) => {
                state.runHistory = []; // reset
                state.logData = []; // reset

                state.status = 'succeeded';
                state.runHistory = action.payload.results;
            })
            .addCase(getLogData.pending, (state) => {
                state.logdataLoadingStatus = 'loading';
            })
            .addCase(getLogData.fulfilled, (state, action) => {
                state.logData = []; // reset
                state.logdataLoadingStatus = 'succeeded';
                state.logData = action.payload;
            })
            .addCase(getLogData.rejected, (state, action) => {
                state.logdataLoadingStatus = 'failed';
                state.error = action.error.message;
            });
    },
});

// Export the actions (if you have any synchronous reducers)
// export const { addIntegration } = integrationSlice.actions;

// Export the actions (if you have any synchronous reducers)
export const {
    updateIntegrationSourceDetails,
    updateIntegrationDestinationDetails,
    updateIntegrationMappingDetails,
    addIntegration, updateIntegration,
    updateWorkflow,
    updateIntegrationTriggerDetails,
    updateWorkflowNodePosition,
    addActionToWorkflow,
    updateWorkflowNode,
    deleteWorkflowNode
} = integrationSlice.actions;


// Export the reducer
export default integrationSlice.reducer;
